// Global variable
  var disabledDate = [];
  var theme_settings = Shopify.theme_settings.date_block;
  theme_settings = theme_settings.split(',');
  var disabledSpecificDays = disabledDate.concat(theme_settings);

  var $imgContainer = $('#Alt_Product');
  var $childArrayElement = $imgContainer.find('.product-gallery--image');
  var $navContainer = $('.selectedNav');
  var $navCell = $('.product-gallery--thumbnail-trigger');
  var $templateName = $('#js_template').attr('data-template');
$(function(){
  openStorePopupOnload();
  $template = $('#js_template').val();
  if ($template == 'true'){
    destroyProductSlider();
    onloadGetProductImgArray();
  }

  deliveryDate();
  redirectCollection();
  //rentalInstallationDate();
  checkOptionWidth();
});

// Start Img alt text function
onloadGetProductImgArray = () =>{
    var $isShow = false;
    var $childArray = $imgContainer.children();
    var $flickityConfig = $imgContainer.attr('data-flickity');
    var $obj = JSON.parse($flickityConfig);

    // remove all product image
    $childArrayElement.remove();
    $navCell.remove();

    // Loop radio value checked and append the correct cell
    var $selectedOption = '';
    $('.option-value-input:checked').each(function(){
      $selectedOption += '-' + $(this).val().toLowerCase();
    });

    for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = '-' + $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
      if ($thisAltText.includes('-main_image') || $thisAltText.includes($selectedOption) ) {
        $imgContainer.append($childArrayElement[i]);
        $isShow = true;
        console.log($thisAltText);
      }
    }

    for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = '-' + $($navCell[i]).attr('data-img-alt').toLowerCase();
      if ($thisAltText.includes('-main_image') || $thisAltText.includes($selectedOption) ) {
        $navContainer.append($navCell[i]);
        $isShow = true;
      }
    }
    initProductSlider($isShow,$obj);
}

variantImageSwap = (evt,optionVal) =>{
  var $this = $(evt);
  var $isShow = false;
  var $flickityConfig = $imgContainer.attr('data-flickity');
  var $obj = JSON.parse($flickityConfig);

  // Destroy slider
  destroyProductSlider();

  // remove thumbnail image
  $childArrayElement.remove();
  $navCell.remove();

  // Loop radio value checked and append the correct cell
  var $selectedOption = '';
  $('.option-value-input:checked').each(function(){
    $selectedOption += '-' + $(this).val().toLowerCase();
  });

  for (var i = 0; i < $childArrayElement.length; i++) {
  var $thisAltText = '-' + $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
    if ($thisAltText.includes('-main_image') || $thisAltText.includes($selectedOption) ) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
  }

  for (var i = 0; i < $navCell.length; i++) {
  var $thisAltText = '-' + $($navCell[i]).attr('data-img-alt').toLowerCase();
    if ($thisAltText.includes('-main_image') || $thisAltText.includes($selectedOption) ) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }
  }

  initProductSlider($isShow,$obj);
}

initProductSlider = (isShow,obj) =>{
  if (isShow) {
    $imgContainer.flickity(obj);

    // Flickity instance
    var flkty = $imgContainer.data('flickity');
    // elements
    var $cellButtonGroup = $('.selectedNav');
    var $cellButtons = $cellButtonGroup.find('.product-gallery--thumbnail-trigger');

    // update selected cellButtons
    $imgContainer.on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '.product-gallery--thumbnail-trigger', function() {
      var index = $(this).index();
      $imgContainer.flickity( 'select', index );
    });
    // // previous
    // $('.button--previous').on( 'click', function() {
    //   $imgContainer.flickity('previous');
    // });
    // // next
    // $('.button--next').on( 'click', function() {
    //   $imgContainer.flickity('next');
    // });
  }
}

destroyProductSlider = () =>{
  var $carousel = $('#Alt_Product').flickity();
  var isFlickity = true;
  if ( isFlickity ) {
    $carousel.flickity('destroy');
    console.log(isFlickity,'isFlickity');
  }
}
// End Img alt text function

// Pdp Popup Image start
openPopup = (evt) =>{
  var $this = $(evt);
  var $popup_modal = $('#modal--container');
  var $popupImage = $('.popup-variant-img');
  var $popupImgContainer = $imgContainer.find('.is-selected');
  var $childPopupImg = $popupImgContainer.find('.product-galley--image-background');
  var $childImgSrc = $childPopupImg.attr('data-image');
  var $imagePop = $('.zoom-wrap');

  $popupImage.remove();
  $popup_modal.show().css('display','block');
  $imagePop.html('<img class="popup-variant-img" src="' +$childImgSrc +'"/>');
}

closePop = () =>{
  $('#modal--container').css('display','none');
}
// Pdp Popup Image end

// Block Sunday only
var blockDate = function(date) {
                    var day = date.getDay();
                    return [(day != 0), ''];
                }

deliveryDate = () =>{
  $("#preferred-delivery-date").datepicker({
    minDate: +7,
    maxDate: '+2M',
    beforeShowDay: disableSpecificDaysAndWeekends,
    dateFormat: "dd-mm-yy"
  });
}

function disableSpecificDaysAndWeekends(d) {
  const date = new Date(d)
  var m = date.getMonth() + 1
  var d = date.getDate()
  var y = date.getFullYear();

  const day = date.getDay();
  if (disabledSpecificDays.includes(`${d}-${m}-${y}`)) {
    return [false]
  }
  if (new Date() > date) {
    return [false]
  }
  var weekend = true;
  if (day == 0 || day == 6) {
    weekend = false;
  }
  return [weekend]
}

redirectCollection = () =>{
  var $url = window.location.pathname;
  if ($url.includes('collections/all')) {
    window.location.href = '/';
  }
}

//rentalInstallationDate = () => {
  //$("#_rentalDate").datepicker( {
    //minDate: +0,
    //maxDate: '+2M',
    //dateFormat: 'dd-mm-yy',
    //beforeShowDay: jQuery.datepicker.noWeekends

  //});
//}

closePopup = () =>{
  $('.jsc-popup-overlay').hide();
  $('.jsc-popup-wrap').hide();
  setSStoragePopup();
}
setSStoragePopup = () =>{
  sessionStorage.setItem("isClosedStore", true);
}
openStorePopupOnload = () =>{
  var $getSessionStorage = sessionStorage.getItem("isClosedStore");

  if (!$getSessionStorage) {
    setTimeout(function(){
      $('.jsc-popup-overlay').show();
      $('.jsc-popup-wrap').show();
    },2000);
  }
}
checkOptionWidth = () => {
  if ($('.option-values').length) {
    var width = $('.option-values').width();
    console.log('Width of .option-values:', width);
    
    var newWidth = width - 30;
    console.log('New width for .option-value-input + .option-value-name:', newWidth);
    
    $('.option-value-input + .option-value-name').css('max-width', newWidth + 'px');
  } else {
    console.log('.option-values does not exist.');
  }
}
$(window).resize(function() {
  checkOptionWidth();
});
